import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const FAQ = () => {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: t('faq.q1'),
    answer: t('faq.a1')
  }, {
    question: t('faq.q2'),
    answer: t('faq.a2')
  }, {
    question: t('faq.q3'),
    answer: t('faq.a3')
  }, {
    question: t('faq.q4'),
    answer: t('faq.a4')
  }, {
    question: t('faq.q5'),
    answer: t('faq.a5')
  }, {
    question: t('faq.q6'),
    answer: t('faq.a6')
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-8 md:py-16 bg-gray-50" data-id="element-35">
      <div className="container mx-auto px-3 md:px-8" data-id="element-36">
        <div className="bg-blue-800 text-white py-2 md:py-3 px-4 md:px-6 rounded-t-lg inline-block mb-4 md:mb-8" data-id="element-37">
          <h2 className="text-base md:text-xl font-bold" data-id="element-38">{t('faq.header')}</h2>
        </div>
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6 md:mb-10" data-id="element-39">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200 last:border-b-0" data-id="element-40">
              <button className="flex justify-between items-center w-full p-4 md:p-6 text-left focus:outline-none" onClick={() => toggleFAQ(index)} data-id="element-41">
                <span className="text-base md:text-lg font-semibold text-gray-800" data-id="element-42">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="text-blue-600" size={20} data-id="element-43" /> : <ChevronDown className="text-blue-600" size={20} data-id="element-44" />}
              </button>
              {openIndex === index && <div className="px-4 md:px-6 pb-4 md:pb-6" data-id="element-45">
                  <p className="text-sm md:text-base text-gray-700" data-id="element-46">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
};